import React from "react";
import "./portfolioCarousel.css";
import "../services/services.css";
function PortfolioHeadings() {
  return (
    <div className="PortfolioheadingContainer" id="portfolio">
      <h1 className="serviceTitle">Portfolio</h1>

      <h1 className="serviceDescription">The Most Loved Work</h1>
    </div>
  );
}

export default PortfolioHeadings;
